import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import gpp from '../../assets/images/Technology Associations/3gpp.png'
import onem2m from '../../assets/images/Technology Associations/onem2m.com.png'
import TCOE from '../../assets/images/Technology Associations/TCOE.png'
import TSDSI from '../../assets/images/Technology Associations/TSDSI.png'




function TechnologyAssocations() {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: false,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <section className="mb-50">
      <div className="container">
        <h2 className="text-center py-20">Technology Assocations</h2>
        <Slider {...settings}>
          <div className="slide-item px-1 ">
            <div className="about-randd wow fadeInUp delay-0-2s">
              <div className="icon">
                <img className="tech-associations" src={gpp} alt="gpp Logo"  />
              </div>
            </div>
          </div>

          <div className="slide-item px-1 ">
            <div className="about-randd wow fadeInUp delay-0-2s">
              <div className="icon ">
                <img className="ind-partner" src={onem2m} alt="ONEM2M Logo" />
              </div>
            </div>
          </div>

          <div className="slide-item px-1">
            <div className="about-randd wow fadeInUp delay-0-2s">
              <div >
                <img  src={TCOE} alt="TCOE Logo" className="tech-associations"/>
              </div>
            </div>
          </div>

          <div className="slide-item px-1">
            <div className="about-randd wow fadeInUp delay-0-2s">
              <div className="icon">
                <img className="tech-associations" src={TSDSI} alt="SIAINDIA Logo"  />
              </div>
            </div>
          </div>
          

        </Slider>
      </div>


    </section>
  );
}

export default TechnologyAssocations;
